import { createSelector } from "@reduxjs/toolkit";

const selectAuth = (state) => state.auth;

export const selectCurrentOrg = createSelector([selectAuth], (auth) =>
  auth.user?.organisations?.find(
    (org) => org?.orgId?._id === auth.user?.selectedOrg
  )
);

export const selectCurrentOrgSetupItems = createSelector(
  [selectCurrentOrg],
  (currentOrg) => currentOrg?.orgId?.setupItems
);

export const selectIsCurrentOrgOwner = createSelector(
  [selectAuth, selectCurrentOrg],
  (auth, currentOrg) =>
    currentOrg?.orgId?.users?.find((u) => u?.user === auth.user?._id)
      ?.role === "owner"
);
